export function retryableLazyImport<T>(
  importFunc: () => Promise<{ default: T }>,
  retries = 3,
  delay = 1500
): Promise<{ default: T }> {
  return new Promise((resolve, reject) => {
    function attempt(remaining: number) {
      importFunc()
        .then(resolve)
        .catch((error) => {
          if (remaining <= 1) {
            reject(error);
          } else {
            setTimeout(() => attempt(remaining - 1), delay);
          }
        });
    }
    attempt(retries);
  });
}
